import g from "@/util/global-whitelist.mjs";

export async function checkPageVisibility() {
  if (g.document.visibilityState === "visible") return;
  await new Promise<void>((resolve) => {
    g.document.addEventListener("visibilitychange", onVisibilityChange, false);
    function onVisibilityChange() {
      if (g.document.visibilityState !== "visible") return;
      resolve();
      g.document.removeEventListener("visibilitychange", onVisibilityChange);
    }
  });
}
